/* eslint-disable @typescript-eslint/no-explicit-any */
// import { Checkbox } from '@/components/_shadcn-ui/checkbox';
import { handleDomBubbleEvent } from '@/utils/dom';
import { memo, useCallback } from 'react';
import { useCustomerModuleModalRootActionsStore } from '@/features/customers/_shared/components/customer-modal-root/customer-modal-root.store';
import { useUpdateDetailCustomerModalStore } from './update-detail-customer-modal.store';
import { useShallow } from 'zustand/shallow';
import { Modal, ModalHeader, ModalTitle, ModalContent, ModalFooter, ModalCloseButton } from '@/components/_ui/modal';
import { Checkbox } from '@/components/_ui/checkbox';

export type TUpdateDetailCustomerModalType = 'UpdateDetailCustomerModal';
export interface IUpdateDetailCustomerModalProps {
  onConfirm?: () => void;
}

const UpdateDetailCustomerModal = memo((_props: IUpdateDetailCustomerModalProps) => {
  const customerModalRootActions = useCustomerModuleModalRootActionsStore();
  const { showData, setShowData } = useUpdateDetailCustomerModalStore(
    useShallow((state) => ({
      showData: state.showData,
      setShowData: state.setShowData,
    }))
  );

  const isAllChecked = Object.entries(showData)
    .filter(([key]) => key !== 'name')
    .every(([, value]) => value);

  const checkedCount = Object.entries(showData).filter(([, value]) => value).length;
  const totalCount = Object.keys(showData).length;

  const handleToggleAll = useCallback(
    (checked: boolean) => {
      const newShowData = { ...showData };
      Object.keys(showData).forEach((key) => {
        if (key !== 'name') {
          (newShowData as any)[key] = checked;
        }
      });
      setShowData(newShowData);
    },
    [showData, setShowData]
  );

  const handleToggleField = useCallback(
    (key: string, value: boolean) => {
      if (key !== 'name') {
        setShowData({ ...showData, [key]: !value });
      }
    },
    [showData, setShowData]
  );

  const handleClose = useCallback(() => {
    customerModalRootActions.closeModal('UpdateDetailCustomerModal');
  }, [customerModalRootActions]);

  const getFieldLabel = (key: string): string => {
    if (key === 'phoneNumber') return 'Phone Number';
    return key.charAt(0).toUpperCase() + key.slice(1);
  };

  return (
    <Modal
      isCloseOutside={false}
      isButtonClose={true}
      onClose={handleClose}
      className="w-[400px] p-[24px]"
      isOpen={customerModalRootActions.checkIsOpenModal('UpdateDetailCustomerModal')}
      lockBodyScroll
    >
      <ModalHeader>
        <ModalTitle>Select Field</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <div className="grid max-h-[260px] overflow-y-auto border border-[#D9D9D9] rounded-[8px]">
          {/* Header with "Show All" checkbox */}
          <div className="sticky top-0 bg-[#0C8DBF] z-10 p-[16px] border-b border-[#D9D9D9] rounded-t-[8px]">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-[8px]">
                <Checkbox
                  id="show-all-data"
                  className="border-white bg-white outline-hidden data-[state=checked]:text-[#0C8DBF] data-[state=checked]:bg-white data-[state=checked]:border-[#0C8DBF] data-[state=unchecked]:text-white data-[state=unchecked]:bg-white data-[state=unchecked]:border-[#D9D9D9]"
                  checked={isAllChecked}
                  onCheckedChange={handleToggleAll}
                />
                <label htmlFor="show-all-data" className="text-[12px] font-normal text-white pl-[8px] cursor-pointer">
                  Show All
                </label>
              </div>
              <div className="flex items-center gap-[8px]">
                <span className="text-[12px] font-normal text-white">
                  {checkedCount} <span className="px-[4px]">/</span> {totalCount}
                </span>
              </div>
            </div>
          </div>

          {/* Field checkboxes */}
          <div className="flex flex-col">
            {Object.entries(showData).map(([key, value]) => {
              const isNameField = key === 'name';

              return (
                <div
                  key={key}
                  className="flex items-center cursor-pointer gap-[8px] p-[16px] border-b border-[#D9D9D9] last:border-b-0"
                  onClick={() => handleToggleField(key, value)}
                >
                  <Checkbox
                    id={`show-data-${key}`}
                    checked={isNameField ? true : value}
                    disabled={isNameField}
                    className="border-white bg-white outline-hidden data-[state=checked]:text-[#0C8DBF] data-[state=checked]:bg-white data-[state=checked]:border-[#0C8DBF] data-[state=unchecked]:text-white data-[state=unchecked]:bg-white data-[state=unchecked]:border-[#D9D9D9] disabled:opacity-50 disabled:cursor-not-allowed"
                  />
                  <label
                    className={`text-[12px] font-normal cursor-pointer pl-[8px] ${isNameField ? 'text-[#9D9D9C]' : 'text-[#25151E]'}`}
                  >
                    {getFieldLabel(key)}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleClose();
          }}
        >
          Close
        </ModalCloseButton>
      </ModalFooter>
    </Modal>
  );
});

UpdateDetailCustomerModal.displayName = 'UpdateDetailCustomerModal';
export default UpdateDetailCustomerModal;
